import { SortDirection, TableSort } from "@redotech/redo-views-common/table";
import { DEFAULT_PAGE_SIZE, viewTypes } from "./views";

export enum OrderTrackingOrdersSystemView {
  ALL = "all",
}

export const orderTrackingOrderSortDefault: TableSort = {
  direction: SortDirection.DESC,
  key: "createdAt",
};

const defaultColumns = [
  { key: "name", width: 100, hidden: false },
  { key: "customer_name", width: 150, hidden: false },
  { key: "shipment_status", width: 140, hidden: false },
  { key: "carrier", width: 120, hidden: false },
  { key: "tracking_number", width: 160, hidden: false },
  { key: "destination", width: 150, hidden: false },
  { key: "return_portal", width: 120, hidden: false },
  { key: "date_created", width: 130, hidden: false },
  { key: "shipment_date", width: 130, hidden: false },
  { key: "expected_delivery", width: 130, hidden: false },
];

export const StaticSystemViews: Record<
  OrderTrackingOrdersSystemView,
  viewTypes["order-tracking-orders"]
> = {
  [OrderTrackingOrdersSystemView.ALL]: {
    table: "order-tracking-orders",
    name: OrderTrackingOrdersSystemView.ALL,
    filters: [],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: orderTrackingOrderSortDefault,
    position: 0,
    isNotEditable: true,
  },
};

export function friendlyOrderTrackingOrderViewName(viewName: string): string {
  switch (viewName) {
    case OrderTrackingOrdersSystemView.ALL:
      return "All";
    default:
      return viewName;
  }
}
